export default __webpack_public_path__ + "static/media/waves.acc42c92.ogg";